var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v("\n       아들 이름: "+_vm._s(_vm.name)+"\n    ")]),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{on:{"click":_vm.call}},[_vm._v("call")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }